import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import {
  CountryMarketConfig,
  Language,
} from '../../common/CountryMarketConfig';
import { RootState } from '../../shared/store';

type CountryMarketState = {
  countryMarketConfig: CountryMarketConfig | null | undefined;
  locale?: Language;
};

const initialState: CountryMarketState = {
  countryMarketConfig: undefined,
};

export const state = createSlice({
  name: 'countryMarketState',
  initialState,
  reducers: {
    resetAll: (state) => {
      delete state.countryMarketConfig;
    },
    setCountryMarketConfig: (
      state,
      action: PayloadAction<CountryMarketConfig | undefined>,
    ) => {
      state.countryMarketConfig = action.payload;
    },
    setLocale: (state, action: PayloadAction<Language | undefined>) => {
      state.locale = action.payload;
    },
  },
});

export const useCountryMarketState = (): [
  CountryMarketState,
  typeof state.actions,
] => [useSelector((state: RootState) => state.countryMarket), state.actions];

export const actions = state.actions;

export const reducers = state.reducer;
